import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

export const setShowPstTasksMutator: (show: boolean) => void = mutatorAction(
    'setShowPstTasks',
    (show: boolean): void => {
        getStore().showPstTasks = show;
    }
);
